'use client'

import { useCallback } from 'react'
import { Button, ButtonGroup } from '@mui/material'
import JsCookie from 'js-cookie'

// Types
import type { LanguageSwitcherProps } from '@/types/components/molecules/language-switcher'

// Configurations
import Config from '@/config'
import LocaleConfig from '@/config/locale'

// Language buttons: stores the choice in a cookie and reopens the current page in that language
const LanguageSwitcherMolecule = (props: LanguageSwitcherProps) => {
	// Props
	const { lng, labels } = props

	// Callbacks
	const switchLanguage = useCallback(
		(targetLng: string) => {
			JsCookie.set(`${Config.shortName}-locale`, targetLng, {
				path: '/',
				secure: true,
				sameSite: 'lax',
				expires: new Date(Date.now() + 86400000 * 366)
			})

			window.location.href = window.location.pathname.replace(`/${lng}`, `/${targetLng}`)
		},
		[lng]
	)

	if (LocaleConfig.list.length < 2) return null

	return (
		<ButtonGroup variant="text" sx={{ '& .MuiButtonGroup-grouped': { borderColor: 'transparent !important' } }}>
			{LocaleConfig.list.map(lang => (
				<Button
					key={lang}
					disabled={lng === lang}
					onClick={() => switchLanguage(lang)}
					sx={{
						minWidth: 36,
						px: 1,
						fontSize: 13,
						fontWeight: lng === lang ? 700 : 400,
						color: 'grey.600',
						borderRadius: 1.5,
						'&.Mui-disabled': { color: 'text.primary', fontWeight: 700 },
						'&:hover': { bgcolor: '#f5f5f7' }
					}}
				>
					{labels[lang as keyof typeof labels] ?? lang}
				</Button>
			))}
		</ButtonGroup>
	)
}

export default LanguageSwitcherMolecule
